import { RequestCanceledError } from "@/common/http/ApiError";
import store from "@/store/index";

export const handleError = (error, info) => {
  // Silently ignore canceled requests - they're not errors, just expected behavior
  // when navigating away or when new requests supersede old ones
  if (error instanceof RequestCanceledError || error?.name === "RequestCanceledError" || error?.code === "ERR_CANCELED") {
    return;
  }

  try {
    store.commit("setError", error);
    if (error?.name !== "ApiError") {
      // eslint-disable-next-line no-console
      console.error(error, info);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`Can't display error: ${error}`);
  }
};

export const setupErrorHandling = (vueConfig) => {
  // Main Vue error handler
  // error: complete error trace, contains the message and error stack
  // vm: Vue component/instance in which error is occurred (a lot of not very useful info)
  // info: Vue specific error information such as lifecycle hooks, events etc.
  vueConfig.errorHandler = (error, vm, info) => {
    handleError(error, info);
  };

  // For promise rejections.
  // With async/await exception correctly bubbles up and stops execution vs.
  // in case of promise, when it's just an error report.
  window.addEventListener("unhandledrejection", (event) => {
    // event.reason contains the error object
    // event.promise contains the promise object, no valuable extra info there
    const error = event.reason;

    // Prevent browser from logging canceled request errors to console
    if (error instanceof RequestCanceledError || error?.name === "RequestCanceledError" || error?.code === "ERR_CANCELED") {
      event.preventDefault();
      return;
    }

    handleError(error, {
      promise: true,
      warning: "Consider converting to async/await to properly bubble exception up.",
    });
  });

  // For errors that happened outside Vue framework,
  // like if something breaks during initialization in main.js or during lib initialization.
  // Should be very rare.
  window.onerror = (message, source, lineno, colno, error) => {
    handleError(error, {
      message,
      source,
      lineno,
      colno,
    });
  };
};
